document.addEventListener('DOMContentLoaded', function () {
    if (window.location.href.indexOf("skinsize-diagnostic") === -1) {
        // only run this on the appropriate page
        return;
    }

    const expandButton = document.querySelector(".skinsize-diagnostic .expand-button")
    const formSubmission = document.querySelector(".form-submission-container")
    expandButton.addEventListener("click", () => {
        formSubmission.classList.toggle("active")
    })
})
